import {Base64} from 'js-base64'

function cloneAttributes(target, source) {
	;[...source.attributes].forEach(attr => {
		target.setAttribute(attr.nodeName, attr.nodeValue)
	})
}

document.querySelectorAll('.cfac-btn').forEach(btn => {
	const value = Base64.decode(btn.dataset.cfacbtnVal)

	// print internal links directly as <a href="..."></a>
	if (
		btn.dataset.cfacbtnAction === 'go' &&
		['url', 'email'].includes(btn.dataset.cfacbtnType) &&
		/^(?:https?:)?\/\/www\.asiago\.it(?:$|\/)/i.test(value)
	) {
		const link = document.createElement('a')
		cloneAttributes(link, btn)
		link.href = value
		link.target = '_blank'
		link.dataset.cfacbtnInternal = true
		btn.parentNode.replaceChild(link, btn)
		btn = link
	} else if (
		btn.dataset.cfacbtnAction === 'go' &&
		['url'].includes(btn.dataset.cfacbtnType) &&
		!/^(?:https?:)?\/\//i.test(value)
	) {
		const span = document.createElement('span')
		span.innerHTML = value
		btn.parentNode.replaceChild(span, btn)
		btn = span
	}

	if (btn.dataset.cfacbtnLabel) {
		btn.dataset.cfacbtnLabel = Base64.decode(btn.dataset.cfacbtnLabel)
		btn.classList.add('cfac-btn--show-label')
	}
})

document.body.addEventListener('click', function (event) {
	const btn = event.target

	if (!btn.matches('.cfac-btn') || !btn.matches(':empty')) {
		return
	}

	const value = Base64.decode(btn.dataset.cfacbtnVal)
	let interactionsTypesId

	switch (btn.dataset.cfacbtnAction) {
		case 'show':
			switch (btn.dataset.cfacbtnType) {
				case 'tel':
					interactionsTypesId = 6
					break
				case 'email':
					interactionsTypesId = 7
					break
			}
			btn.innerHTML = value
			break
		case 'go':
			switch (btn.dataset.cfacbtnType) {
				case 'tel':
					interactionsTypesId = 8
					break
				case 'email':
					interactionsTypesId = 9
					break
				case 'url':
					interactionsTypesId = 12
					break
			}

			if (btn.dataset.cfacbtnInternal !== 'true') {
				window.open(value, '_blank')
			}

			break
	}

	fetch('/clienteventslogger.ashx', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			interactionsTypesId,
			content: value,
			idLingua: WC.idLingua,
			idMenu: WC.idMenu,
			idArticolo: WC.idArticolo,
			idElemento: btn.dataset.cfacbtnCid,
			url: window.location.href,
			screenResolution:
				window.screen.width && window.screen.height
					? window.screen.width + 'x' + window.screen.height
					: null,
		}),
	})
})
